'use strict';
import {buildLogger} from '../logger';

export const logger = buildLogger('loading-icon');



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/logger.js